import eventBus from '@eventBus/index';

import { EventBusTypes } from '../../enums/eventBusTypes.enum';
import { EventBusCallbackType } from '../../interfaces/callback.interface';
import { EmptyFunction } from '../../interfaces/emptyFunction.interface';
import { TUpdateProjectPlusProps } from './updateProjectPlusProps.interface';

const eventName = EventBusTypes.UPDATE_ENTITY_DETAILS_LIST;

const subscribe = (
  callback: EventBusCallbackType<TUpdateProjectPlusProps>
): EmptyFunction => {
  return eventBus.subscribe<TUpdateProjectPlusProps>(eventName, callback);
};

const broadcast = (data: TUpdateProjectPlusProps): void => {
  eventBus.broadcast<TUpdateProjectPlusProps>(eventName, data);
};

export default {
  subscribe,
  broadcast,
};
